import { generatePath } from 'react-router';
import { paths } from '@AppRoutes/constants';

function removeEmptyParams(params) {
  return Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== null && v !== undefined && v !== ''));
}
export function generateResultsPath(params) {
  return generatePath(paths.RESULTS, removeEmptyParams(params));
}

export function generateHeatmapPath(params) {
  return generatePath(paths.HEATMAP, removeEmptyParams(params));
}
